import { render, staticRenderFns } from "./AssociatedMaterial.vue?vue&type=template&id=66085a66&scoped=true"
import script from "./AssociatedMaterial.vue?vue&type=script&lang=js"
export * from "./AssociatedMaterial.vue?vue&type=script&lang=js"
import style0 from "./AssociatedMaterial.vue?vue&type=style&index=0&id=66085a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66085a66",
  null
  
)

export default component.exports